var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"page-container mb-3 px-0 mt-4 hidden-sm-and-up"},[_c('h4',{staticClass:"textColor fs-16"},[_vm._v(_vm._s(_vm.$t('Список ПУТЭ')))])]),_c('MetersTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }